module.exports = __webpack_public_path__ + "img/auth-back.46159012.png";